import { StudentStatus } from "./types"

// 学生状态标签映射：用于 UI 文案展示
// 使用 Record 保证枚举项映射的完备性（漏项会在编译时报错）
export const StudentStatusLabels: Record<StudentStatus, string> = {
  [StudentStatus.INTERVENING]: "干预中",
  [StudentStatus.LEFT]: "已离园",
}

// 学生状态颜色映射：用于 UI 展示
export const StudentStatusColors: Record<StudentStatus, string> = {
  [StudentStatus.INTERVENING]: "green",
  [StudentStatus.LEFT]: "default",
}

// 姓名验证规则常量
export const NAME_VALIDATION = {
  /** 姓名最小长度 */
  MIN_LENGTH: 2,
  /** 姓名最大长度 */
  MAX_LENGTH: 20,
  /** 姓名正则表达式（只允许中文、英文和空格） */
  PATTERN: /^[\u4e00-\u9fa5a-zA-Z\s]+$/,
  /** 最小长度错误消息 */
  MIN_MESSAGE: "姓名至少2个字符",
  /** 最大长度错误消息 */
  MAX_MESSAGE: "姓名不能超过20个字符",
  /** 格式错误消息 */
  PATTERN_MESSAGE: "姓名只能包含中文、英文和空格",
  /** 必填错误消息 */
  REQUIRED_MESSAGE: "请输入学生姓名",
} as const

// 备注验证规则常量
export const NOTE_VALIDATION = {
  /** 备注最大长度 */
  MAX_LENGTH: 500,
  /** 最大长度错误消息 */
  MAX_MESSAGE: "备注不能超过500个字符",
} as const
